module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAUBJREFUSA1jZGj4z8bwh6GJ4T9DHBBLMpAPvgK1XmFgYpjJ0MywgIGR8T/IKEaGmv8dDP8Yysk3F6vOTQxsDKEMDYy/WMAuB6lhYvBmaGHchlU5MYIN/yWAIeEPdGwvULkfkN0CpMsYGar+g73C0MbISIw5BNVU/7cAqjkMdPhfoC/UmAhqIFVBK+MJoJZFQMzO8IuhgPoWQBy0EEwxMhiyQPhYyOr/W4He9MIigynEyLCNoZXRGy7BzXCd4QuYp0UtH0DiEWZDFeNrMPM/gxhuHyC7CK6R9ARBLR/AnIBBj1qAESToAqNBhB4iGHyaBxHujIbhFqAAqEhgABYgJADSLMCWuwlYRvMgooMFjAzPwb6s+o8obgl4m6A0zCyg2bSq9CFuYGLoZGFgYagDVtCgtEFpswXhMVCoMAKrTaDZAHAvRc0YxDgCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sign/icon-lybt.png
// module id = 423
// module chunks = 2